import classNames from 'classnames'
import React from 'react'

import classes from './expenseTag.module.css'

function ExpenseTag({ type, value }) {
  return (
    <div className={classes.expensetag}>
      <div className={classNames(classes.arrowWrapper, classes[`arrowWrapper_${type}`])}>
        <div className={classNames(classes.arrow, classes[`arrow_${type}`])} />
      </div>
      <p>{`$${value?.toLocaleString()}`}</p>
    </div>
  )
}

export default ExpenseTag
